import {isMobile, updateCatalogDropdownHeight} from "./utils";

$(function(){
  const $header = $('.js-header');
  const $page = $('.js-page');
  const fixedActiveClass = 'header--fixed';
  const headerHeight = $header.outerHeight(true);
  const $productCardHeader = $('.js-product-card-header');
  
  const detectVisibleProductHeader = () => {
    if(isMobile()) return;
    updateCatalogDropdownHeight();
    if($(window).scrollTop() > 200){
      $page.css('margin-top', headerHeight);
      $header.addClass(fixedActiveClass);
      $productCardHeader.addClass('is-showed')
    } else {
      $page.css('margin-top', 0);
      $header.removeClass(fixedActiveClass)
      $productCardHeader.removeClass('is-showed')
    }
  }
  detectVisibleProductHeader();
  $(window).on('scroll', detectVisibleProductHeader)
});